export class UserSettings {
  private static userViewOptions: any = {};

  static getGlobalDateDisplayFormat(key: string = 'code', extended = false): string {
    const { globalDateFormat } = this.getUserViewOptions();
    const dateOpt = !!globalDateFormat && globalDateFormat.length ? globalDateFormat[0] : null;

    if (!!dateOpt) {
      return (extended && `${dateOpt[key]} h:mm:ss a`) || dateOpt[key];
    }

    return key !== 'code'
      ? (extended && 'MM/DD/YYYY h:mm:ss a') || 'MM/DD/YYYY'
      : (extended && 'M/d/yyyy h:mm:ss a') || 'M/d/yyyy';
  }

  static getRentConfiguration() {
    const { rents } = this.getUserViewOptions();
    return rents;
  }

  /**
   * Safely return if the user rent preference is yearly
   *
   * @return true by default or if user rent settings is yearly
   */
  static isYearlyPreference() {
    const rents = UserSettings.getRentConfiguration();
    const rentsOpt = !!rents && rents.length > 0 ? rents[0] : null;
    // define display preference (by default is yearly)
    return !!rentsOpt ? !!rentsOpt && rentsOpt.code === 'Yearly' : true;
  }

  private static getUserViewOptions() {
    const userProfileSettings = localStorage.getItem('USER_SETTINGS')
      ? JSON.parse(localStorage.getItem('USER_SETTINGS'))
      : null;
    if (
      userProfileSettings != null &&
      userProfileSettings.userSettings != null &&
      userProfileSettings.userSettings.viewOptions != null
    ) {
      const { userSettings } = userProfileSettings;
      const { viewOptions } = userSettings;
      this.userViewOptions = viewOptions;
    } else {
      this.userViewOptions = { rents: null, globalDateFormat: null };
    }
    return this.userViewOptions;
  }

  /**
   * Return the global date display format without the day
   * @param portion - 'd' for day, 'y' for year, 'm' for month
   * @returns string
   * @example
   * const format = getGlobalDateDisplayFormatWithoutDay();
   * if the format === 'MM/DD/YYYY';
   * then returns 'MM/YYYY'
   */
  static getGlobalDateDisplayFormatPortion(portion: 'd' | 'y' | 'm' = 'd', key: string = 'code', extended = false) {
    const userFormat = UserSettings.getGlobalDateDisplayFormat(key, extended);
    if (!['d', 'y', 'm'].includes(portion)) {
      return userFormat;
    }
    const formartSeparator = userFormat.split('').find(char => ['/', ' ', '-'].includes(char));
    if (formartSeparator === undefined) {
      return userFormat;
    }

    return userFormat
      .split(formartSeparator)
      .filter(e => !e.toLowerCase().includes(portion))
      .join(formartSeparator);
  }
}
